import React from 'react';

const ClockArrowUpIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M12 6v6l1.56.78"/>
            <path d="M13.227 21.925a10 10 0 1 1 8.767-9.588"/>
            <path d="m14 18 4-4 4 4"/>
            <path d="M18 22v-8"/>
        </svg>
    );
};

export default ClockArrowUpIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ClockArrowUpIcon.jsx